import { gql } from '@apollo/client';

import { subjectsTreeFragment } from '../fragments';

export default gql`
  mutation DeleteSubject($courseId: String!, $subjectId: String!) {
    subjects(courseId: $courseId, subjectId: $subjectId)
      @rest(type: "Subject", path: "courses/{args.courseId}/subjects/{args.subjectId}", method: "DELETE") {
      ...SubjectsTree
    }
  }
  ${subjectsTreeFragment}
`;
